module.exports = __webpack_public_path__ + "assets/img/title-9c133a6b.png";